import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_close.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-4 w-4",
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["inline-flex items-center gap-2 rounded-lg border border-gray-lp-400 bg-white px-2 py-2 text-sm", _ctx.disabled ? 'text-gray-lp-500' : 'text-gray-lp-300']
  }, [
    _createVNode("span", null, _toDisplayString(_ctx.timeSlot.start) + " - " + _toDisplayString(_ctx.timeSlot.end), 1),
    (_ctx.removable)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          type: "button",
          disabled: _ctx.disabled,
          class: _ctx.disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove')))
        }, [
          _hoisted_1
        ], 10, ["disabled"]))
      : _createCommentVNode("", true)
  ], 2))
}